import axios from 'axios'

const baseURL = import.meta.env.VITE_API_ADV_URL || 'https://api.revolution.wortise.com'

export const apiAdv = axios.create({
  baseURL
})
